// extracted by mini-css-extract-plugin
export default {"stars":"HomePage_stars__bLBn9","middleStar":"HomePage_middleStar__JseRt"};